import { Button, Tag } from '@chakra-ui/react';
import { PropertyDetailsFragment } from '@client/graphql/__generated__/types';
import { useNavigate } from 'react-router';
import { getOffMarketListingPath } from '~/apps/consumer/utils/routes.utils';
import { BaseListingCard } from './BaseListingCard';

export const PropertyDetailsCard = ({
  propertyDetails,
  showButton = false,
}: {
  propertyDetails: PropertyDetailsFragment;
  showButton?: boolean;
}) => {
  const navigate = useNavigate();

  const topTags = (
    <Tag bg="white" color="indigo.900" lineHeight={1} textTransform="none">
      Off Market
    </Tag>
  );

  const navigateToOffMarketListing = () => {
    navigate(getOffMarketListingPath(propertyDetails.id));
  };

  const button = (
    <Button
      _hover={{
        textDecoration: 'none',
        bgColor: 'primaryButton.300', // Somehow setting textDecoration to none removes the hover bg color, so manually setting it
      }}
      borderRadius="sm"
      fontSize="sm"
      mt={2}
      size="xs"
      variant="solid"
      onClick={navigateToOffMarketListing}
    >
      See listing offer data
    </Button>
  );

  return (
    <BaseListingCard
      area={propertyDetails.areaSqFt}
      bathrooms={String(
        (propertyDetails.bathsFull || 0) + (propertyDetails.bathsHalf || 0)
      )}
      bedrooms={propertyDetails.bedrooms}
      button={showButton ? button : undefined}
      city={propertyDetails.city}
      daysOnMarket={0}
      price={propertyDetails.targetPrice}
      state={propertyDetails.state}
      streetName={propertyDetails.streetAddress}
      topTags={topTags}
      unit={propertyDetails.unit}
      zipCode={propertyDetails.zipCode}
      onClick={navigateToOffMarketListing}
    />
  );
};
